import Component from '@glimmer/component';
import { PrismTooltip } from '@mylighthouse/prism-ember';
import dayjs from 'dayjs';

interface GeneralCalendarsMonthsCalendarMonthRangeTooltipSignature {
  Args: {
    date: unknown;
    dateTooltips: unknown;
  };
}

export default class GeneralCalendarsMonthsCalendarMonthRangeTooltip extends Component<GeneralCalendarsMonthsCalendarMonthRangeTooltipSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get tooltipForDate() {
    const { dateTooltips, date } = this.args;

    if (!dateTooltips || !date) {
      return null;
    }

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
    const tooltipForDate = dateTooltips.find((dateTooltip) => {
      // @ts-expect-error: Incorrect type
      const dateDayjs = dayjs(date);
      return (
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        dateDayjs.isAfter(dateTooltip.startDate) ||
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        dateDayjs.isSame(dateTooltip.startDate)
      );
    });

    if (tooltipForDate) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
      return tooltipForDate.tooltipText;
    }

    return null;
  }

  <template>
    {{#if this.tooltipForDate}}
      <PrismTooltip @side="top" @text={{this.tooltipForDate}} />
    {{/if}}
  </template>
}
